/* The Wandered Piece — redesign interactions. No dependencies. Progressive: the page is complete without this file. */
(function () {
  'use strict';
  var d = document, root = d.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  root.classList.add('twp-js');
  var clamp = function (v, a, b) { return Math.max(a, Math.min(b, v)); };

  /* ---------- scroll-driven updates (one passive listener, rAF-batched) ---------- */
  var scrollFns = [], ticking = false;
  function runScroll() { ticking = false; for (var i = 0; i < scrollFns.length; i++) scrollFns[i](); }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(runScroll); } }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });

  /* ---------- progress line ---------- */
  function initProgress() {
    if (reduce || d.querySelector('.twp-progress')) return;
    var bar = d.createElement('div'); bar.className = 'twp-progress'; bar.setAttribute('aria-hidden', 'true');
    d.body.appendChild(bar);
    scrollFns.push(function () {
      var max = root.scrollHeight - innerHeight;
      bar.style.transform = 'scaleX(' + (max > 0 ? clamp(scrollY / max, 0, 1) : 0) + ')';
    });
  }

  /* ---------- reveals (elements only hide once JS has registered them) ---------- */
  function revealAll() { d.querySelectorAll('.twp .rv').forEach(function (e) { e.classList.add('in'); }); }
  function initReveals(scope) {
    var els = Array.prototype.slice.call(scope.querySelectorAll('.rv:not(.rv-wait)'));
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 });
    var vh = innerHeight;
    els.forEach(function (e) {
      var top = e.getBoundingClientRect().top;
      if (top < vh * 0.95) { e.classList.add('in'); return; } // already on screen: never hide it
      e.classList.add('rv-wait'); io.observe(e);
    });
  }


  /* ---------- floating puzzle pieces (drawn inside the silk canvas, behind the ribbons) ----------
     Pre-rendered sprites (one per colour x depth), so each frame is just drawImage calls.
     Pieces fade out over the text zone ([data-drift-avoid]) — fully on phones, mostly on desktop. */
  var DRIFT_COLORS = [['#D4AF37', 'rgba(212,175,55,'], ['#2dd4bf', 'rgba(45,212,191,'], ['#F5E070', 'rgba(245,224,112,'], ['#a78bfa', 'rgba(167,139,250,']];
  function piecePath(ctx, s, e) { // 1x1 piece centred at 0,0; e = [top,right,bottom,left] tab direction (1 out, -1 in)
    var h = s / 2, n = s * 0.17, w = s * 0.11;
    ctx.beginPath(); ctx.moveTo(-h, -h);
    ctx.lineTo(-w, -h); ctx.bezierCurveTo(-w * 1.6, -h - n * e[0], w * 1.6, -h - n * e[0], w, -h); ctx.lineTo(h, -h);
    ctx.lineTo(h, -w); ctx.bezierCurveTo(h + n * e[1], -w * 1.6, h + n * e[1], w * 1.6, h, w); ctx.lineTo(h, h);
    ctx.lineTo(w, h); ctx.bezierCurveTo(w * 1.6, h + n * e[2], -w * 1.6, h + n * e[2], -w, h); ctx.lineTo(-h, h);
    ctx.lineTo(-h, w); ctx.bezierCurveTo(-h - n * e[3], w * 1.6, -h - n * e[3], -w * 1.6, -h, -w);
    ctx.closePath();
  }
  function makeSprite(col, depth, px) { // depth 0 far .. 2 near
    var size = Math.ceil(px * 1.9), c = d.createElement('canvas'); c.width = c.height = size;
    var x = c.getContext('2d'); x.translate(size / 2, size / 2);
    var edges = [[1, -1, 1, -1], [1, 1, -1, -1], [-1, 1, 1, -1]][depth];
    if (depth === 0 && 'filter' in x) x.filter = 'blur(' + Math.max(1, px * 0.05).toFixed(1) + 'px)';
    piecePath(x, px, edges);
    var g = x.createLinearGradient(-px / 2, -px / 2, px / 2, px / 2);
    g.addColorStop(0, col[1] + (depth === 2 ? '.10)' : '.05)')); g.addColorStop(1, col[1] + '0)');
    x.fillStyle = g; x.fill();
    x.shadowBlur = px * (depth === 0 ? 0.35 : 0.22); x.shadowColor = col[1] + '.75)';
    x.lineWidth = Math.max(1, px * (depth === 2 ? 0.026 : 0.034)); x.strokeStyle = col[0]; x.stroke();
    x.shadowBlur = 0; x.globalAlpha = .55; x.lineWidth = Math.max(.6, px * 0.01); x.strokeStyle = '#fff6d8'; x.stroke();
    return c;
  }
  function Drift(cfg, mobile) {
    var n = mobile ? cfg.mobile : cfg.desktop, list = [], sprites = {}, unit = 1, zones = [];
    var cnv = null, hz = null, hdrEls = d.querySelectorAll('.shopify-section-group-header-group, .shopify-section-group-header-group header-component'); // header/menu: pieces fully fade out behind it
    for (var i = 0; i < n; i++) {
      var depth = i % 5 === 0 ? 2 : (i % 2 ? 0 : 1); // ~20% near, ~40% mid, ~40% far
      var z = [0.35, 0.65, 1][depth] + Math.random() * 0.15;
      var ci = Math.random() < 0.08 ? 3 : (Math.random() < 0.55 ? 0 : (Math.random() < 0.75 ? 1 : 2)); // gold-led, teal, pale gold, rare violet
      list.push({
        x: Math.random(), y: Math.random(), depth: depth, z: z, ci: ci,
        vx: (0.00005 + Math.random() * 0.00009) * z * (Math.random() < 0.7 ? 1 : -1),
        vy: -(0.00003 + Math.random() * 0.00007) * z,
        a: Math.random() * 6.28, va: Math.random() < 0.55 ? (Math.random() - 0.5) * 0.004 : 0,
        bob: Math.random() * 6.28, ox: 0, oy: 0,
        alpha: [0.28, 0.5, 0.75][depth] * (0.75 + Math.random() * 0.25) * (mobile ? 0.85 : 1.1) * (cfg.fade || 1)
      });
    }
    function sizeTo(W, H, cssW, canvas) {
      unit = W / Math.max(1, cssW);
      var base = (mobile ? 30 : 46) * unit * (cfg.scale || 1);
      sprites = {};
      list.forEach(function (p) {
        p.px = Math.round(base * [0.45, 0.75, 1.25][p.depth] * (0.85 + (p.z % 0.15) * 2));
        var key = p.ci + '-' + p.depth + '-' + p.px;
        p.spr = sprites[key] || (sprites[key] = makeSprite(DRIFT_COLORS[p.ci], p.depth, p.px));
      });
      zones = [];
      cnv = canvas;
      var host = canvas.parentElement, cr = canvas.getBoundingClientRect();
      host.querySelectorAll('[data-drift-avoid]').forEach(function (el) {
        var r = el.getBoundingClientRect(), pad = (mobile ? 14 : 40);
        zones.push([(r.left - cr.left - pad) * unit, (r.top - cr.top - pad) * unit, (r.right - cr.left + pad) * unit, (r.bottom - cr.top + pad) * unit, pad * unit]);
      });
    }
    function headerZone() {
      hz = null; if (!cnv || !hdrEls.length) return;
      var cr = cnv.getBoundingClientRect(), b = -1e9;
      for (var i = 0; i < hdrEls.length; i++) { var r = hdrEls[i].getBoundingClientRect(); if (r.height) b = Math.max(b, r.bottom); }
      if (b <= cr.top) return;
      var pad = mobile ? 14 : 24;
      hz = [(b - cr.top) * unit, pad * unit]; // fade fully above this line, ramp over pad below it
    }
    function zoneFade(x, y, r) {
      var f = 1, yt = y - (r || 0); // r: half the piece size, so no edge pokes into the header
      if (hz) { if (yt < hz[0]) return 0; if (yt < hz[0] + hz[1]) f = (yt - hz[0]) / hz[1]; }
      for (var i = 0; i < zones.length; i++) {
        var z = zones[i], dx = Math.max(z[0] - x, 0, x - z[2]), dy = Math.max(z[1] - y, 0, y - z[3]);
        var dist = Math.sqrt(dx * dx + dy * dy), k = clamp(dist / z[4], 0, 1);
        f = Math.min(f, (mobile ? 0 : 0.22) + (mobile ? 1 : 0.78) * k);
      }
      return f;
    }
    function draw(ctx, W, H, st, moving) {
      headerZone();
      ctx.globalCompositeOperation = 'source-over';
      for (var i = 0; i < list.length; i++) {
        var p = list[i];
        if (moving) {
          p.x += p.vx; p.y += p.vy; p.a += p.va;
          if (p.x < -0.08) p.x = 1.08; if (p.x > 1.08) p.x = -0.08;
          if (p.y < -0.1) { p.y = 1.1; p.x = Math.random(); }
        }
        var x = p.x * W + (st.px - 0.5) * 40 * unit * p.z + Math.sin(st.t * 0.7 + p.bob) * 6 * unit * p.z;
        var y = p.y * H + (st.py - 0.5) * 24 * unit * p.z - st.scrollP * H * 0.35 * p.z + Math.cos(st.t * 0.5 + p.bob) * 5 * unit;
        if (moving && st.amt > 0.01) { // soft push away from the cursor/finger
          var dx = x - st.px * W, dy = y - st.py * H, dd = Math.sqrt(dx * dx + dy * dy), R = 160 * unit;
          if (dd < R && dd > 0) { var f = (1 - dd / R) * st.amt * 0.9 * unit; p.ox += dx / dd * f; p.oy += dy / dd * f; }
        }
        p.ox *= 0.96; p.oy *= 0.96; x += p.ox; y += p.oy;
        var s = p.spr.width, a = p.alpha * zoneFade(x, y, s * 0.45); if (a < 0.02) continue;
        ctx.globalAlpha = a;
        if (p.a) { ctx.save(); ctx.translate(x, y); ctx.rotate(p.a); ctx.drawImage(p.spr, -s / 2, -s / 2); ctx.restore(); }
        else ctx.drawImage(p.spr, x - s / 2, y - s / 2);
      }
      ctx.globalAlpha = 1;
    }
    return { size: sizeTo, draw: draw };
  }


  /* ---------- page-wide floating pieces: ONE fixed canvas behind all content (z-index:-1, pointer-events:none).
     Opaque sections (hero, newsletter, images, cards) cover it naturally; text zones fade pieces out.
     Reduced motion: not created at all (the hero keeps its static pieces). ---------- */
  function PageDrift(count) {
    if (reduce || d.querySelector('.twp-pagedrift')) return;
    var mobile = innerWidth < 750, n = mobile ? Math.max(5, Math.round(count * 0.5)) : count;
    var c = d.createElement('canvas'); c.className = 'twp-pagedrift'; c.setAttribute('aria-hidden', 'true');
    d.body.insertBefore(c, d.body.firstChild); root.classList.add('twp-drift-on');
    var ctx = c.getContext('2d'); if (!ctx) return;
    var dpr = Math.min(window.devicePixelRatio || 1, 1.5), W = 1, H = 1, cssW = 0, cssH = 0, raf = 0, list = [], zones = [], zonesDirty = true;
    var lastY = scrollY, t = 0, hero = d.querySelector('.twp-hero'), covered = false;
    var textSel = '.twp:not(.twp-hero):not(.twp-news) :is(h2,h3,p,li,blockquote,figcaption,.twp-eyebrow,.twp-num,.twp-link,.twp-btn,.twp-spec,.twp-quote,form), .twp-footer :is(a,p,h3,h4,span,div.twp-footer__brand)';
    var hdrEls = d.querySelectorAll('.shopify-section-group-header-group, .shopify-section-group-header-group header-component'), hdrB = -1e9; // header/menu: fully faded
    var textEls = Array.prototype.slice.call(d.querySelectorAll(textSel));
    for (var i = 0; i < n; i++) {
      var depth = i % 5 === 0 ? 2 : (i % 2 ? 0 : 1), z = [0.35, 0.65, 1][depth] + Math.random() * 0.15;
      var ci = Math.random() < 0.62 ? 0 : 2; // below the hero: gold and pale gold only
      list.push({ x: Math.random(), y: Math.random(), depth: depth, z: z, ci: ci,
        vx: (0.00004 + Math.random() * 0.00007) * z * (Math.random() < 0.7 ? 1 : -1), vy: -(0.00003 + Math.random() * 0.00006) * z,
        a: Math.random() * 6.28, va: Math.random() < 0.55 ? (Math.random() - 0.5) * 0.004 : 0, bob: Math.random() * 6.28,
        alpha: [0.25, 0.45, 0.64][depth] * (0.75 + Math.random() * 0.25) * (mobile ? 0.85 : 1) * 0.7 }); // toned down below the hero
    }
    function size(force) {
      var w = innerWidth, h = Math.max(innerHeight, d.documentElement.clientHeight);
      if (!force && w === cssW && Math.abs(h - cssH) < 120) return; // ignore mobile URL-bar jitter
      cssW = w; cssH = h;
      W = c.width = Math.round(w * dpr); H = c.height = Math.round(h * dpr);
      var base = (mobile ? 30 : 44) * dpr, sprites = {};
      list.forEach(function (p) {
        p.px = Math.round(base * [0.45, 0.75, 1.2][p.depth]);
        var key = p.ci + '-' + p.depth + '-' + p.px;
        p.spr = sprites[key] || (sprites[key] = makeSprite(DRIFT_COLORS[p.ci], p.depth, p.px));
      });
      zonesDirty = true;
    }
    function buildZones() {
      zonesDirty = false; zones = []; hdrB = -1e9;
      for (var k = 0; k < hdrEls.length; k++) { var hb = hdrEls[k].getBoundingClientRect(); if (hb.height && hb.bottom > 0) hdrB = Math.max(hdrB, hb.bottom * dpr); }
      var pad = (mobile ? 10 : 30);
      for (var i = 0; i < textEls.length; i++) {
        var r = textEls[i].getBoundingClientRect();
        if (r.bottom < -pad || r.top > cssH + pad || !r.width) continue;
        zones.push([(r.left - pad) * dpr, (r.top - pad) * dpr, (r.right + pad) * dpr, (r.bottom + pad) * dpr, pad * dpr]);
      }
      if (hero) { var hr = hero.getBoundingClientRect(); covered = hr.top <= 0 && hr.bottom >= cssH; }
    }
    function fade(x, y, r) {
      var f = 1, lo = mobile ? 0 : 0.25, yt = y - (r || 0), hp = (mobile ? 14 : 24) * dpr;
      if (yt < hdrB) return 0; if (yt < hdrB + hp) f = (yt - hdrB) / hp;
      for (var i = 0; i < zones.length; i++) {
        var q = zones[i], dx = Math.max(q[0] - x, 0, x - q[2]), dy = Math.max(q[1] - y, 0, y - q[3]);
        if (dx > q[4] || dy > q[4]) continue;
        f = Math.min(f, lo + (1 - lo) * clamp(Math.sqrt(dx * dx + dy * dy) / q[4], 0, 1));
      }
      return f;
    }
    function frame() {
      raf = requestAnimationFrame(frame);
      var sy = scrollY, dy = sy - lastY; lastY = sy;
      if (dy) zonesDirty = true;
      if (zonesDirty) buildZones();
      t += 0.006;
      for (var i = 0; i < list.length; i++) { // drift + depth parallax (far pieces move less with the page)
        var p = list[i]; p.x += p.vx; p.y += p.vy - dy * 0.22 * p.z / Math.max(1, cssH); p.a += p.va;
        if (p.x < -0.08) p.x = 1.08; if (p.x > 1.08) p.x = -0.08;
        if (p.y < -0.1) { p.y = 1.1; p.x = Math.random(); } if (p.y > 1.12) { p.y = -0.08; p.x = Math.random(); }
      }
      if (covered) { ctx.clearRect(0, 0, W, H); return; } // hero fills the screen: nothing of this layer is visible
      ctx.clearRect(0, 0, W, H);
      for (var j = 0; j < list.length; j++) {
        var q = list[j], x = q.x * W + Math.sin(t * 0.7 + q.bob) * 6 * dpr * q.z, y = q.y * H + Math.cos(t * 0.5 + q.bob) * 5 * dpr;
        var s = q.spr.width, a = q.alpha * fade(x, y, s * 0.45); if (a < 0.02) continue;
        ctx.globalAlpha = a;
        if (q.a) { ctx.save(); ctx.translate(x, y); ctx.rotate(q.a); ctx.drawImage(q.spr, -s / 2, -s / 2); ctx.restore(); }
        else ctx.drawImage(q.spr, x - s / 2, y - s / 2);
      }
      ctx.globalAlpha = 1;
    }
    size(true);
    window.addEventListener('resize', function () { size(false); zonesDirty = true; }, { passive: true });
    if (d.fonts && d.fonts.ready) d.fonts.ready.then(function () { zonesDirty = true; });
    setInterval(function () { zonesDirty = true; }, 1500); // reveals/lazy images can move text slightly
    function start() { if (!raf && !d.hidden) { lastY = scrollY; raf = requestAnimationFrame(frame); } }
    function stop() { if (raf) { cancelAnimationFrame(raf); raf = 0; } }
    d.addEventListener('visibilitychange', function () { if (d.hidden) stop(); else start(); });
    start();
  }

  /* ---------- flowing silk light (canvas 2D) ---------- */
  function Silk(canvas, cfg) {
    var ctx = canvas.getContext('2d'); if (!ctx) return;
    var host = canvas.parentElement;
    var mobile = innerWidth < 750;
    var strands = mobile ? 14 : 24, scale = mobile ? 0.7 : 0.6;
    var W = 1, H = 1, t = cfg.t0 || 0, raf = 0, visible = true;
    var px = 0.5, py = 0.5, tx = 0.5, ty = 0.5, amt = 0, tAmt = 0, scrollP = 0, energy = 0;
    var parts = [];
    var drift = cfg.drift ? Drift(cfg.drift, mobile) : null, moving = false;
    for (var i = 0; i < (mobile ? 40 : 90); i++) parts.push({ x: Math.random(), y: Math.random(), r: Math.random() * 1.4 + 0.3, s: Math.random() * 0.0004 + 0.0001, p: Math.random() * 6.28 });
    function size() {
      var r = canvas.getBoundingClientRect(), dpr = Math.min(window.devicePixelRatio || 1, 2) * scale;
      W = canvas.width = Math.max(1, Math.round(r.width * dpr)); H = canvas.height = Math.max(1, Math.round(r.height * dpr));
      if (drift) drift.size(W, H, r.width, canvas);
    }
    function setPointer(cx, cy) {
      var r = canvas.getBoundingClientRect();
      var nx = (cx - r.left) / r.width, ny = (cy - r.top) / r.height;
      energy = Math.min(1, energy + Math.hypot(nx - tx, ny - ty) * 4);
      tx = nx; ty = ny; tAmt = 1;
    }
    if (cfg.interactive && !reduce) {
      host.addEventListener('pointermove', function (e) { setPointer(e.clientX, e.clientY); }, { passive: true });
      host.addEventListener('pointerdown', function (e) { setPointer(e.clientX, e.clientY); energy = 1; }, { passive: true });
      host.addEventListener('pointerleave', function () { tAmt = 0; });
      host.addEventListener('touchend', function () { setTimeout(function () { tAmt = 0; }, 900); }, { passive: true });
      scrollFns.push(function () { var r = host.getBoundingClientRect(); scrollP = clamp(-r.top / Math.max(1, r.height), 0, 1); });
    }
    function draw() {
      ctx.globalCompositeOperation = 'source-over'; ctx.fillStyle = '#000'; ctx.fillRect(0, 0, W, H);
      if (drift) drift.draw(ctx, W, H, { t: t, px: px, py: py, amt: amt, scrollP: scrollP }, moving);
      ctx.globalCompositeOperation = 'lighter';
      var stepX = (mobile ? 16 : 12) * (W / 1400 + 0.4);
      cfg.ribbons.forEach(function (rb, ri) {
        var g = ctx.createLinearGradient(0, 0, W, 0);
        rb.stops.forEach(function (s) { g.addColorStop(s[0], s[1]); });
        ctx.strokeStyle = g;
        for (var pass = 0; pass < 2; pass++) {
          ctx.lineWidth = pass === 0 ? Math.max(4, W / 180) : Math.max(1, W / 1100);
          var n = pass === 0 ? Math.ceil(strands / 4) : strands;
          for (var i = 0; i < n; i++) {
            var k = i / n, spread = rb.spread * H * (1 + scrollP * 0.8 + energy * 0.25);
            ctx.globalAlpha = (pass === 0 ? rb.alpha * 0.22 : rb.alpha) * (1 - Math.abs(k - 0.5) * 1.4) * (1 - scrollP * 0.5);
            ctx.beginPath();
            for (var x = -20; x <= W + 20; x += stepX) {
              var u = x / W;
              var y = H * rb.y
                + Math.sin(u * rb.f1 * 6.28 + t * rb.s1 + k * 1.2) * H * rb.a1
                + Math.sin(u * rb.f2 * 6.28 - t * rb.s2 + ri) * H * rb.a2
                + (k - 0.5) * spread * (0.6 + 0.4 * Math.sin(u * 5 + t * 0.35 + ri))
                + (u - 0.5) * H * rb.tilt
                - scrollP * H * 0.22 * (0.4 + k);
              if (amt > 0.001) { var dx = u - px, gx = Math.exp(-dx * dx / 0.03) * amt; y += (py * H - y) * 0.32 * gx * (0.6 + 0.4 * k); }
              if (x === -20) ctx.moveTo(x, y); else ctx.lineTo(x, y);
            }
            ctx.stroke();
          }
        }
      });
      for (var j = 0; j < parts.length; j++) {
        var p = parts[j]; p.x += p.s * (1 + energy * 3); if (p.x > 1) p.x = 0;
        var tw = 0.5 + 0.5 * Math.sin(t * 2 + p.p);
        var ppx = p.x * W, ppy = (p.y * 0.7 + 0.15) * H + Math.sin(t + p.p) * 8;
        var near = amt > 0 ? Math.exp(-(Math.pow(ppx / W - px, 2) + Math.pow(ppy / H - py, 2)) / 0.01) * amt : 0;
        ctx.globalAlpha = Math.min(1, 0.22 + 0.6 * tw + near);
        ctx.fillStyle = p.p > 3 ? '#F5E070' : '#bff6ee';
        ctx.beginPath(); ctx.arc(ppx, ppy, p.r * (W / 1400 + 0.5) * (1 + near * 1.5), 0, 6.283); ctx.fill();
      }
      ctx.globalAlpha = 1;
    }
    function loop() {
      px += (tx - px) * 0.06; py += (ty - py) * 0.06; amt += (tAmt - amt) * 0.04; energy *= 0.96;
      t += 0.006 + energy * 0.01;
      moving = true; draw(); raf = requestAnimationFrame(loop);
    }
    size(); draw();
    window.addEventListener('resize', function () { size(); if (!raf) draw(); });
    if (drift) { setTimeout(function () { size(); if (!raf) draw(); }, 1200); if (d.fonts && d.fonts.ready) d.fonts.ready.then(function () { size(); if (!raf) draw(); }); }
    if (reduce) return;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        visible = es[0].isIntersecting;
        if (visible && !raf && !d.hidden) loop();
        if (!visible && raf) { cancelAnimationFrame(raf); raf = 0; }
      }).observe(canvas);
    } else loop();
    d.addEventListener('visibilitychange', function () {
      if (d.hidden && raf) { cancelAnimationFrame(raf); raf = 0; } else if (!d.hidden && visible && !raf) loop();
    });
  }
  var HERO_RIBBONS = [
    { y: .62, a1: .10, a2: .05, f1: .8, f2: 1.7, s1: .9, s2: .6, spread: .16, tilt: -.22, alpha: .32, stops: [[0, 'rgba(45,212,191,0)'], [.25, '#2dd4bf'], [.6, '#7dd8f0'], [1, 'rgba(167,139,250,0)']] },
    { y: .58, a1: .08, a2: .06, f1: 1.1, f2: .6, s1: .7, s2: .9, spread: .10, tilt: -.18, alpha: .36, stops: [[0, 'rgba(168,124,16,0)'], [.35, '#D4AF37'], [.7, '#F5E070'], [1, 'rgba(232,99,26,0)']] },
    { y: .70, a1: .07, a2: .04, f1: .6, f2: 2.1, s1: .5, s2: .8, spread: .08, tilt: -.26, alpha: .26, stops: [[0, 'rgba(167,139,250,0)'], [.5, '#a78bfa'], [.85, '#c4aafd'], [1, 'rgba(167,139,250,0)']] },
    { y: .55, a1: .05, a2: .03, f1: 1.4, f2: .9, s1: 1.1, s2: .4, spread: .05, tilt: -.15, alpha: .14, stops: [[0, 'rgba(240,236,228,0)'], [.55, '#f0ece4'], [1, 'rgba(240,236,228,0)']] }
  ];
  var NEWS_RIBBONS = [
    { y: .55, a1: .12, a2: .05, f1: .7, f2: 1.5, s1: .6, s2: .5, spread: .22, tilt: .1, alpha: .12, stops: [[0, 'rgba(212,175,55,0)'], [.5, '#D4AF37'], [1, 'rgba(45,212,191,.6)']] },
    { y: .6, a1: .09, a2: .04, f1: 1.0, f2: .8, s1: .5, s2: .7, spread: .12, tilt: .06, alpha: .10, stops: [[0, 'rgba(45,212,191,0)'], [.6, '#2dd4bf'], [1, 'rgba(45,212,191,0)']] }
  ];

  /* ---------- the two pieces: drift apart, snap together on scroll / hover / tap ---------- */
  function initPair(pair) {
    var a = pair.querySelector('.pc-a'), b = pair.querySelector('.pc-b');
    if (!a || !b) return;
    var sep = reduce ? 0 : 1, target = sep, hover = false, tapped = false, snapped = false, scrollT = 1, raf = 0, hero = pair.closest('.twp-hero') || pair;
    function apply() {
      a.style.transform = 'translate(' + (-26 * sep) + 'px,' + (7 * sep) + 'px) rotate(' + (-11 * sep) + 'deg)';
      b.style.transform = 'translate(' + (26 * sep) + 'px,' + (-9 * sep) + 'px) rotate(' + (9 * sep) + 'deg)';
      if (sep < 0.05 && !snapped) {
        snapped = true; pair.classList.remove('is-snapped'); void pair.offsetWidth; pair.classList.add('is-snapped');
        if (navigator.vibrate && tapped) try { navigator.vibrate(12); } catch (e) {}
      } else if (sep > 0.3 && snapped) { snapped = false; pair.classList.remove('is-snapped'); }
    }
    function tick() {
      target = (hover || tapped) ? 0 : scrollT;
      sep += (target - sep) * 0.13;
      if (Math.abs(target - sep) < 0.001) sep = target;
      apply();
      raf = sep !== target ? requestAnimationFrame(tick) : 0;
    }
    function kick() { if (!raf) raf = requestAnimationFrame(tick); }
    if (reduce) { pair.classList.add('is-snapped'); apply(); return; }
    scrollFns.push(function () {
      var r = hero.getBoundingClientRect();
      var p = clamp(-r.top / Math.max(1, r.height * 0.3), 0, 1); // fully snapped after ~30% of the hero scrolls by
      scrollT = 1 - p; kick();
    });
    if (fine) {
      pair.addEventListener('pointerenter', function () { hover = true; kick(); });
      pair.addEventListener('pointerleave', function () { hover = false; kick(); });
    }
    function toggle() { tapped = !tapped; kick(); }
    pair.addEventListener('click', toggle);
    pair.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); } });
    apply(); onScroll();
  }

  /* ---------- collection cards: 3D tilt + cursor sheen ---------- */
  function initTilt(card) {
    if (!fine || reduce) return;
    var raf = 0, ev = null;
    card.addEventListener('pointermove', function (e) {
      ev = e; card.classList.add('is-tilting');
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = 0; var r = card.getBoundingClientRect();
        var x = (ev.clientX - r.left) / r.width, y = (ev.clientY - r.top) / r.height;
        card.style.setProperty('--rx', ((0.5 - y) * 8).toFixed(2) + 'deg');
        card.style.setProperty('--ry', ((x - 0.5) * 10).toFixed(2) + 'deg');
        card.style.setProperty('--mx', (x * 100).toFixed(1) + '%');
        card.style.setProperty('--my', (y * 100).toFixed(1) + '%');
      });
    });
    card.addEventListener('pointerleave', function () {
      card.classList.remove('is-tilting'); card.style.setProperty('--rx', '0deg'); card.style.setProperty('--ry', '0deg');
    });
  }

  /* ---------- product cards: tap toggle for the wall view on touch ---------- */
  function initFlip(card) {
    var btn = card.querySelector('.twp-pcard__flip'); if (!btn) return;
    btn.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var on = card.classList.toggle('show-alt'); btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  /* ---------- magnetic buttons ---------- */
  function initMagnet(btn) {
    if (!fine || reduce) return;
    var label = btn.querySelector('span');
    btn.addEventListener('pointermove', function (e) {
      var r = btn.getBoundingClientRect();
      var x = e.clientX - (r.left + r.width / 2), y = e.clientY - (r.top + r.height / 2);
      btn.style.transform = 'translate(' + (x * 0.22).toFixed(1) + 'px,' + (y * 0.32).toFixed(1) + 'px)';
      if (label) label.style.transform = 'translate(' + (x * 0.1).toFixed(1) + 'px,' + (y * 0.12).toFixed(1) + 'px)';
    });
    btn.addEventListener('pointerleave', function () { btn.style.transform = ''; if (label) label.style.transform = ''; });
  }

  /* ---------- count-up numeral ---------- */
  function initCount(el) {
    var to = parseInt(el.getAttribute('data-countup'), 10); if (!to || reduce || !('IntersectionObserver' in window)) return;
    if (el.getBoundingClientRect().top < innerHeight) return; // already visible: leave the real number
    el.textContent = '0';
    var io = new IntersectionObserver(function (es) {
      if (!es[0].isIntersecting) return; io.disconnect();
      var t0 = performance.now(), dur = 1700;
      (function step(now) {
        var p = clamp((now - t0) / dur, 0, 1), e = 1 - Math.pow(1 - p, 4);
        el.textContent = Math.round(to * e); if (p < 1) requestAnimationFrame(step);
      })(t0);
    }, { threshold: 0.5 });
    io.observe(el);
  }

  /* ---------- gentle parallax ---------- */
  function initParallax(el) {
    if (reduce) return;
    var k = parseFloat(el.getAttribute('data-parallax')) || 0.06;
    scrollFns.push(function () {
      var r = el.getBoundingClientRect(); if (r.bottom < -200 || r.top > innerHeight + 200) return;
      var c = (r.top + r.height / 2 - innerHeight / 2);
      el.style.setProperty('--py', (-c * k).toFixed(1) + 'px');
    });
  }

  function init(scope) {
    scope = scope || d;
    initReveals(scope);
    scope.querySelectorAll('[data-twp-silk]').forEach(function (c) {
      if (c.__twp) return; c.__twp = 1;
      var kind = c.getAttribute('data-twp-silk');
      var dn = parseInt(c.getAttribute('data-drift') || '0', 10), drift = null;
      if (dn > 0) drift = kind === 'news' ? { desktop: dn, mobile: Math.max(3, Math.round(dn / 2)), fade: 0.75, scale: 0.85 } : { desktop: dn, mobile: Math.max(6, Math.round(dn * 0.5)) };
      Silk(c, kind === 'news' ? { t0: 9, ribbons: NEWS_RIBBONS, interactive: true, drift: drift } : { t0: 3, ribbons: HERO_RIBBONS, interactive: true, drift: drift });
    });
    var pd = scope.querySelector('[data-drift-page]');
    var pdn = pd ? parseInt(pd.getAttribute('data-drift-page'), 10) : 0;
    if (pd && scope === d && pdn > 0) PageDrift(pdn);
    scope.querySelectorAll('[data-twp-pair]').forEach(function (p) { if (!p.__twp) { p.__twp = 1; initPair(p); } });
    scope.querySelectorAll('[data-tilt]').forEach(function (c) { if (!c.__twp) { c.__twp = 1; initTilt(c); } });
    scope.querySelectorAll('.twp-pcard').forEach(function (c) { if (!c.__twp) { c.__twp = 1; initFlip(c); } });
    scope.querySelectorAll('[data-magnetic]').forEach(function (c) { if (!c.__twp) { c.__twp = 1; initMagnet(c); } });
    scope.querySelectorAll('[data-countup]').forEach(function (c) { if (!c.__twp) { c.__twp = 1; initCount(c); } });
    scope.querySelectorAll('[data-parallax]').forEach(function (c) { if (!c.__twp) { c.__twp = 1; initParallax(c); } });
    onScroll();
  }
  window.TWP = { init: init, revealAll: revealAll };
  function boot() { initProgress(); init(d); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
  // Theme editor: re-init a section when it is re-rendered
  d.addEventListener('shopify:section:load', function (e) { init(e.target); revealAll(); });
})();
